import { MessageSchema } from '../../realm/schema';
import { chatViewStyles } from './ChatViewItemRender';
import { MessageType } from '../../constants/types';
import React from 'react';
import { GestureResponderEvent, Text } from 'react-native';
import { VoiceContentIntent, VoiceContentRender } from './components/VoiceContentRender';
import { TalkContentRender } from './TalkContentRender';
import { ImageContentRender } from './components/ImageContentRender';
import { VideoContentRender } from './components/VideoContentRender';
import { TextContentRender } from './components/TextRender';
import { RTCRender } from './components/RTCRender';
import { DocumentRender } from './components/DocumentRender';
export type ContentRenderProps = {
	item: MessageSchema;
	isSelf: boolean;
	isAdmin?: boolean;
	adminUids?: number[];
	isBold?: boolean;
	adminColor?: string;
	disabled?: boolean;
	pdLeft?: number;
	pdRight?: number;
	onLongPress?: (event: GestureResponderEvent) => void;
	onClick?(): void; // 单击事件
	talkSelectStatus?: boolean;
	translate?: string;
	voiceRef?: React.RefObject<VoiceContentIntent>;

	auditStatus?: number;
	isTalk?: boolean
};
export const ContentRender = (props: ContentRenderProps) => {
	const textStyle = props.isSelf ? chatViewStyles.sendedText : chatViewStyles.receivedText;
	switch (props.item.type) {
		case MessageType.TEXT:
			return <TextContentRender {...props} />;
		case MessageType.VOICE:
			return <VoiceContentRender {...props} ref={props.voiceRef} styles={textStyle} />;
		case MessageType.VIDEO:
			return <VideoContentRender {...props} />;
		case MessageType.IMAGE:
			return <ImageContentRender {...props} />;
		case MessageType.TALK:
			return <TalkContentRender {...props} />;
		case MessageType.LOCAL_TIME:
			return props.item.content ? <Text style={textStyle}>{props.item.content}</Text> : null;
		case MessageType.RTC_VIDEO:
		case MessageType.RTC_VOICE:
			return <RTCRender {...props} />;
		case MessageType.DOCUMENT:
			return <DocumentRender {...props} />;
		default:
			return props.item.content ? <Text style={textStyle}>{props.item.content}</Text> : null;
	}
};
